<template>
    <div class="m-tab">
        <div class="img-view"><img v-bind:src="'https://web-resource.17m3.com/m3guo/202111/a20211124back/images/m/tab/'+ (default_index + 1) + '.png'" alt=""></div>

        <div class="tab-hd">
            <div class="u-btn tab-item" 
            v-for="(item,index) in collapse_data" 
            :class="[{act : index == default_index},'t-' + index]"
            :key="index"
            @click="default_index=index"
            >{{ item.title }}</div>
        </div>
    </div>
</template>

<style scoped>
.img-view{
    position: relative;
    width: 666px;
    height: 488px;
    margin: 0 auto;
    background-image: url(../images/m/tab-img.png);
}

.img-view img{
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 656px;
    height: 474px;
    transform: translate(-50%,-50%);
}

.m-tab{
    margin-top: 5px;
}

.m-tab .tab-item{
  width: 99px;
  height: 102px;
  font-size: 0;
  color: transparent; 
}

.tab-hd{
    display: flex;
    justify-content: space-between;
    margin: 35px 60px 0;
}

.t-0{
  background-image: url(../images/m/swiper-1.png);
}

.act.t-0{
  background-image: url(../images/m/swiper-1-act.png);
}

.t-1{
  background-image: url(../images/m/swiper-2.png);
}

.act.t-1{
  background-image: url(../images/m/swiper-2-act.png);
}

.t-2{
  background-image: url(../images/m/swiper-3.png);
}

.act.t-2{
  background-image: url(../images/m/swiper-3-act.png);
}

.t-3{
  background-image: url(../images/m/swiper-4.png);
}

.act.t-3{
  background-image: url(../images/m/swiper-4-act.png);
}
</style>

<script>
export default {
  data () {
    return {
      collapse_data : [
        {
          title : '回归福利',
          img : '1',
        },
        {
          title : '活跃任务',
          img : '2',
        },
        {
          title : '回归签到',
          img : '3',
        },
        {
          title : '回归特惠',
          img : '4',
        },                                    
      ],
      default_index : 0,
      now : 0,
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/tab.vue